import moment from "moment";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { deleteAdHocSurveyAsync, refreshAdHocSurveyMetadata } from "../../Helpers/API/AdHocSurveyApi";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";

const AdHocSurveyTableRow = (props) => {
	const { adHocSurvey, deleteRow } = props;

	const deleteAdHocSurveyOnClick = (name) => {
		async function deleteAdHocSurvey() {
			const { success } = await deleteAdHocSurveyAsync(adHocSurvey.id);
			if (success) deleteRow(adHocSurvey.id);
		}

		ConfirmDialog({ entityName: name, onDelete: deleteAdHocSurvey });
	};

	const refreshSurveyMetadataOnClick = async () => {
		await refreshAdHocSurveyMetadata(adHocSurvey.id);
	};

	return (
		<tr>
			<td>{adHocSurvey.name}</td>
			<td className="d-none d-sm-table-cell">{adHocSurvey.alchemerId}</td>
			<td className="d-none d-sm-table-cell">{adHocSurvey.emailTemplate}</td>
			<td>
				{adHocSurvey.isGenerated ? (
					<span>
						Sent on&nbsp;
						{moment(adHocSurvey.sendSurveyOn).format("DD/MM/YYYY")}
					</span>
				) : (
					<>
						<Link to={`/adhoc-surveys/update-adhoc-survey/${adHocSurvey.id}`} className="update-link">
							Update
						</Link>
						<Button onClick={() => refreshSurveyMetadataOnClick()} size="sm" variant="primary" className="action-button-padded">
							Refresh Metadata
						</Button>
						<Button onClick={() => deleteAdHocSurveyOnClick(adHocSurvey.name)} size="sm" variant="danger" className="action-button-padded">
							Delete
						</Button>
					</>
				)}
			</td>
		</tr>
	);
};
AdHocSurveyTableRow.propTypes = {
	adHocSurvey: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		alchemerId: PropTypes.string.isRequired,
		emailTemplate: PropTypes.string.isRequired,
		isGenerated: PropTypes.bool.isRequired,
		sendSurveyOn: PropTypes.string.isRequired,
	}).isRequired,
	deleteRow: PropTypes.func.isRequired,
};

export default AdHocSurveyTableRow;
